import { useTranslation } from 'react-i18next';

import { CourseAdminCard } from '@/components/shared/CourseAdminCard';
import { HtmlPreview } from '@/components/ui/custom/dataDisplay/HtmlPreview';
import HomeworkActivity from '@/models/HomeworkActivity';

type ScheduledLessonHomeworkCardProps = {
  homework: HomeworkActivity;
  onEdit: () => void;
  onDelete: () => void | Promise<unknown>;
  isDeleting?: boolean;
};

export default function ScheduledLessonHomeworkCard({
  homework,
  onEdit,
  onDelete,
  isDeleting,
}: ScheduledLessonHomeworkCardProps) {
  const { t } = useTranslation('translation', {
    keyPrefix: 'scheduledLessonReportModal',
  });

  return (
    <CourseAdminCard variant="card" isDeleting={isDeleting}>
      <CourseAdminCard.Header>
        <CourseAdminCard.Leading>
          <CourseAdminCard.TitleBlock>
            <CourseAdminCard.Title className="font-bold text-sm">
              {t('homeworkTitle')}
            </CourseAdminCard.Title>

            <CourseAdminCard.Body>
              <HtmlPreview html={homework.content} className="bg-transparent!" />
            </CourseAdminCard.Body>
          </CourseAdminCard.TitleBlock>
        </CourseAdminCard.Leading>

        <CourseAdminCard.Actions>
          <CourseAdminCard.EditButton onClick={onEdit} />
          <CourseAdminCard.MoreActions>
            <CourseAdminCard.MoreActions.Delete confirm onClick={onDelete} />
          </CourseAdminCard.MoreActions>
        </CourseAdminCard.Actions>
      </CourseAdminCard.Header>
    </CourseAdminCard>
  );
}
